//audio_player
//@see https://codepen.io/honza108/pen/NWrbMMg
if (typeof $ === 'function') {
  $(document).ready(function () {

    var players = $('.audio_player--audio');
    //cancel initialization if no audio object
    if (!players.length || typeof players[0].pause !== 'function') return;

    //walk every player
    players.each(function () {
      var player = $(this),
          timerId;

      player
        //pause all other players and flag player with .playing class
        .on('play', function () {
          players.not(player).each(function () { this.pause(); });
          player.addClass('playing');
        })
        //schedule .playing flag deletion
        .on('pause', function () {
          if (!player[0].seeking) {
            timerId = setTimeout(function () {
              player.removeClass('playing');
            }, 100);
          }
        })
        //cancel .playing flag deletion
        .on('play seeking', function () {
          clearTimeout(timerId);
        });

    });
  });
}
